import { Link } from 'react-router-dom';
import { categories } from '@/data/homeContent';

export function CategoryNav() {
  return (
    <nav className="border-b border-surface-200 bg-white">
      <div className="container-app px-0 sm:px-6 lg:px-8">
        <ul className="carousel-scroll flex gap-0 overflow-x-auto text-sm">
          {categories.map(({ slug, label }) => (
            <li key={slug} className="carousel-item shrink-0">
              <Link
                to={`/catalogo?categoria=${slug}`}
                className="block whitespace-nowrap px-3.5 py-2.5 font-medium text-surface-600 active:bg-surface-100 sm:px-4 sm:py-3"
              >
                {label}
              </Link>
            </li>
          ))}
          <li className="carousel-item shrink-0">
            <Link
              to="/catalogo"
              className="block whitespace-nowrap px-3.5 py-2.5 font-medium text-brand-700 active:bg-brand-50 sm:px-4 sm:py-3"
            >
              Todo
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
